export default {
  root: { height: 45 },
  input: {
    backgroundColor: '#fdfdfd',
    height: 45,
    padding: '8px 14px',
    fontSize: 12,
    boxSizing: 'border-box',
  },
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)',
  },
  adornedStart: { width: '100%' },
};
